// Bulletproof Description Toggle System for Shopify
(function() {
  'use strict';
  
  // Global namespace to avoid conflicts
  window.DescriptionToggle = {
    initialized: false,
    
    init: function() {
      if (this.initialized) return;
      
      console.log('🚀 DescriptionToggle: Starting initialization...');
      console.log('🔍 DescriptionToggle: Looking for elements...');
      
      // Check what elements exist
      var containers = document.querySelectorAll('.product__description[data-block-id]');
      var buttons = document.querySelectorAll('.read-more-btn');
      console.log('📦 DescriptionToggle: Found', containers.length, 'containers and', buttons.length, 'buttons');
      
      this.setupGlobalEventListener();
      this.initializeAllDescriptions();
      this.observeChanges();
      this.initialized = true;
      console.log('✅ DescriptionToggle: Initialized successfully');
    },
    
    setupGlobalEventListener: function() {
      // Use event delegation to handle dynamically added buttons
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('read-more-btn')) {
          e.preventDefault();
          console.log('DescriptionToggle: Button clicked');
          var blockId = e.target.getAttribute('data-block');
          if (blockId) {
            console.log('DescriptionToggle: Toggling block', blockId);
            window.DescriptionToggle.toggle(blockId);
          } else {
            console.warn('DescriptionToggle: No block ID found on button');
          }
        }
      });
    },
    
    toggle: function(blockId) {
      console.log('DescriptionToggle: Toggle called for block', blockId);
      
      var container = document.querySelector('.product__description[data-block-id="' + blockId + '"]');
      if (!container) {
        console.error('DescriptionToggle: Container not found for block', blockId);
        return;
      }
      
      var shortDescription = container.querySelector('.short-description');
      var fullDescription = container.querySelector('.full-description');
      var button = container.querySelector('.read-more-btn');
      
      console.log('DescriptionToggle: Elements found:', {
        shortDescription: !!shortDescription,
        fullDescription: !!fullDescription,
        button: !!button
      });
      
      if (!shortDescription || !fullDescription || !button) {
        console.error('DescriptionToggle: Missing elements in container');
        return;
      }
      
      var isExpanded = fullDescription.style.display !== "none" && fullDescription.style.display !== "";
      console.log('DescriptionToggle: Current state expanded:', isExpanded);
      
      if (isExpanded) {
        // Collapse
        fullDescription.style.display = "none";
        shortDescription.style.display = "block";
        button.setAttribute('aria-expanded', 'false');
        
        // Update button text (CSS handles the "More" part)
        var btnText = button.querySelector('.btn-text');
        if (btnText) {
          btnText.textContent = 'Read';
        }
        
        console.log('DescriptionToggle: Collapsed');
      } else {
        // Expand
        fullDescription.style.display = "block";
        shortDescription.style.display = "none";
        button.setAttribute('aria-expanded', 'true');
        
        // Update button text (CSS handles the "Less" part)
        var btnText = button.querySelector('.btn-text');
        if (btnText) {
          btnText.textContent = 'Read';
        }
        
        console.log('DescriptionToggle: Expanded');
      }
    },
    
    initializeAllDescriptions: function() {
      var containers = document.querySelectorAll('.product__description[data-block-id]');
      console.log('DescriptionToggle: Found', containers.length, 'description containers');
      
      containers.forEach(function(container) {
        var button = container.querySelector('.read-more-btn');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      });
    },
    
    observeChanges: function() {
      // Watch for DOM changes and reinitialize if needed
      if (window.MutationObserver) {
        var observer = new MutationObserver(function(mutations) {
          var shouldReinit = false;
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                    (node.querySelector && node.querySelector('.product__description[data-block-id]')) ||
                    (node.classList && node.classList.contains('product__description'))
                )) {
                  shouldReinit = true;
                }
              });
            }
          });
          
          if (shouldReinit) {
            console.log('DescriptionToggle: DOM changes detected, reinitializing...');
            setTimeout(function() {
              window.DescriptionToggle.initializeAllDescriptions();
            }, 100);
          }
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        
        console.log('DescriptionToggle: MutationObserver set up');
      }
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.DescriptionToggle.init();
    });
  } else {
    window.DescriptionToggle.init();
  }
  
  // Backup function for direct calls (backwards compatibility)
  window.toggleDescription = function(blockId) {
    if (window.DescriptionToggle) {
      window.DescriptionToggle.toggle(blockId);
    }
  };
  
})();
